import { css } from 'styled-components'

export const RadioStyles = (theme) => css`
  [type='radio']:not(:checked),
  [type='radio']:checked {
    left: -9999px;
    position: absolute;
  }

  [type='radio']:not(:checked) + label,
  [type='radio']:checked + label {
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    padding-top: 5px;
    font-weight: 400 !important;
    padding-left: 27px;
    position: relative;
  }

  [type='radio']:not(:checked) + label:before,
  [type='radio']:checked + label:before {
    background: transparent;
    border: 1px solid #afaeae;
    border-radius: 50%;
    content: '';
    height: 18px;
    left: 0;
    position: absolute;
    top: 2px;
    transition: border-color 0.5s ease;
    vertical-align: middle;
    width: 18px;
  }

  [type='radio']:checked + label:before {
    border: 3px solid ${theme.colors.primary};
  }

  // checked
  [type='radio']:not(:checked) + label:after,
  [type='radio']:checked + label:after {
    border-color: #fff;
    border-style: solid;
    border-width: 0 2px 2px 0;
    content: '';
    height: 9px;
    left: 8px;
    opacity: 0;
    position: absolute;
    top: 10px;
    transform: translate(-50%, -65%) rotate(45deg);
    transition: opacity 0.5s ease, visibility 0.5s ease;
    width: 4px;
  }

  [type='radio']:not(:checked) + label:after {
    opacity: 0;
  }

  [type='radio']:checked + label:after {
    opacity: 1;
  }

  // disabled radio
  [type='radio']:disabled:not(:checked) + label:before,
  [type='radio']:disabled:checked + label:before {
    border-color: #cccccc;
    background: #f6f6f6;
  }

  [type='radio']:disabled:checked + label:after {
    color: #999;
  }
`
export const RadioStylesOrigem = (theme) => css`
  /* Ocultar o botão de rádio real */
  [type='radio']:not(:checked),
  [type='radio']:checked {
    left: -9999px;
    position: absolute;
  }

  /* Estilizar o label que representa o botão de rádio */
  [type='radio']:not(:checked) + label,
  [type='radio']:checked + label {
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    padding-top: 5px;
    font-weight: 400 !important;
    padding-left: 27px;
    position: relative;
  }

  /* Círculo do botão de rádio */
  [type='radio']:not(:checked) + label::before,
  [type='radio']:checked + label::before {
    content: '';
    background: transparent;
    border: 1px solid ${theme.colors.error};
    border-radius: 50%;
    height: 18px;
    width: 18px;
    position: absolute;
    left: 0;
    top: 2px;
    transition: background 0.3s ease, border-color 0.3s ease;
  }

  /* Quando o botão de rádio está selecionado, círculo preenchido */
  [type='radio']:checked + label::before {
    background: ${theme.colors.error}; /* Interior do círculo */
    border-color: ${theme.colors.error}; /* Borda */
  }

  /* Estilo do "tick" */
  [type='radio']:not(:checked) + label::after,
  [type='radio']:checked + label::after {
    content: '';
    position: absolute;
    top: 50%; /* Posicionar ao centro verticalmente */
    left: 8px; /* Posicionar ao centro horizontalmente */
    width: 5px; /* Largura do tick */
    height: 10px; /* Altura do tick */
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: translate(-50%, -50%) rotate(45deg); /* Centraliza o tick e aplica a rotação */
    opacity: 0; /* Oculta o tick inicialmente */
    transition: opacity 0.3s ease;
  }

  /* Mostrar o tick quando o rádio está selecionado */
  [type='radio']:checked + label::after {
    opacity: 1;
  }

  /* Estilo para rádio desabilitado */
  [type='radio']:disabled + label::before {
    border-color: #cccccc;
    background: #f6f6f6;
  }

  [type='radio']:disabled:checked + label::after {
    color: #999;
  }
`
